<template>
    <div class="container is-fluid">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <Nav style="margin-bottom: 20px;" />
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-12" style="margin-top: 70px;">
                        <div class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-icon">
                                    <b-icon icon="view-compact"></b-icon>
                                </div>
                                <div class="level-item">
                                    <h4 class="title is-4">{{ $route.name }}</h4>
                                </div>
                                <div class="level-item">
                                    <b-field>
                                        <b-select placeholder="select jobsite" expanded v-model="jobsiteSelect">
                                            <option v-for="item in jobsite"
                                                    :value="item"
                                                    :key="item.id">
                                                {{ item.nameJobsite }}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-warning"
                                              @click="centerUpdate(); showInfo(); jsonConcatNOT(); ">Search</b-button>
                                </div>
                            </div>

                        </div>
                        <section class="box map">
                            <l-map :zoom="zoom" :minZoom="minZoom" :center="center" :options="{zoomControl: false}">
                                <l-control-scale position="bottomleft" :metric="true"></l-control-scale>
                                <l-control-polyline-measure :options="{ unit:'metres', showBearings:false, clearMeasurementsOnStop: false, showClearControl: true, showUnitControl: true }"
                                                            position="topleft" />
                                <l-control-zoom position="topright"></l-control-zoom>
                                <l-tile-layer :url="url"></l-tile-layer>
                                <l-marker :key="index"
                                          v-for="(market,index) in jobsite"
                                          :lat-lng="latLng(market.coordinateLat, market.coordinateLng)"
                                          >
                                    <l-tooltip direction="top">{{market.nameJobsite}}</l-tooltip>
                                    <l-popup @click="jsonConcatNOT()" :jobsiteSelect="market">
                                        <div v-if="verifyWorkUnits(market.workunits)">
                                            <InfoMap :nameJobsite="market.nameJobsite"
                                                     :numberJobsite="market.numberJobsite"
                                                     :location="market.location"
                                                     :workunits="market.workunits"
                                                     :updatedAt="market.updatedAt"
                                                     :adress="market.adress"
                                                     @showComment="jsonConcatNOT()"
                                                     />
                                        </div>
                                        <div v-else>
                                            <div class="media">
                                                <div class="media-content">
                                                    <p class="title is-3 is-uppercase">{{ market.nameJobsite }}</p>
                                                    <p class="subtitle adress-format">{{ market.adress }}</p>
                                                    <p>No data to display yet</p>
                                                </div>
                                            </div>
                                        </div>
                                    </l-popup>
                                    <l-icon :icon-url="icon"
                                            :icon-anchor="iconAnchor"
                                            :icon-size="iconSize"
                                            :shadow-size="shadowSize"
                                            :shadow-anchor="shadowAnchor"
                                            @click="jsonConcatNOT()" />
                                </l-marker>
                                <l-geo-json class="blue" :geojson="geojsonOK" :options-style="styleFunctionOK"></l-geo-json>
                                <l-geo-json class="red" :geojson="geojsonNOT" :options-style="styleFunctionNOT"></l-geo-json>

                            </l-map>
                        </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { LMap, LTileLayer, LGeoJson, LMarker, LIcon, LControlScale, LControlZoom, LTooltip, LPopup } from 'vue2-leaflet'
    import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
    /* import MarkerPopup from '@/components/InfoMap' */
    import icon from '../assets/pin.png'

    // @ is an alias to /src
    import Nav from '@/components/Nav.vue'
    import InfoMap from '@/components/InfoMap.vue'
    import moment from 'moment'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import * as turf from '@turf/turf';
    import {reverse} from 'lodash';

    export default {
        components: {
            Loading,
            Nav,
            InfoMap,
            LMap,
            LTileLayer,
            LGeoJson,
            LMarker,
            LIcon,
            LControlScale,
            LControlZoom,
            LTooltip,
            LPopup,
            LControlPolylineMeasure
        },
        data() {
            return {
                jobsite: [],
                url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
                zoom: 2,
                minZoom: 3,
                center: [20, 10],
                icon: icon,
                jobsiteGeojson: null,
                isActive: false,
                iconSize: [36, 36], // size of the icon
                shadowSize: [50, 64], // size of the shadow
                iconAnchor: [18, 18], // point of the icon which will correspond to marker's location
                shadowAnchor: [4, 62], // the same for the shadow
                workunits: [],
                jobsiteSelect: [],
                geojsonNOT: null,
                geojsonOK: null,
                forceEndDrive: false,
                pathBase: this.$store.getters.pathBase,
                geoJsonToUse: [],
                isBusy: false
            }
        },
        mounted() {
            this.$store.dispatch('verifyAccess').then(() => {
                this.isBusy = true;
                try {
                    this.axios
                        .get('/workunitadvance/getAll')
                        .then(res => {
                            const genericResponse = res.data;
                            this.jobsite = genericResponse.result;
                            this.isBusy = false;
                        })
                        .catch(e => {
                            console.error(e)
                            this.isBusy = false;
                        })
                } catch (e) {
                    console.error(e)
                    this.isBusy = false;
                }
            });
        },
        methods: {
            verifyWorkUnits(workUnits) {
                if (workUnits != null) {
                    for (let i = 0; i < workUnits.length; i++) {
                        if (workUnits[i].workunitadvance != null && workUnits[i].workunitadvance.length > 0) {
                            return true;
                        }
                    }
                }

                return false;
            },
            moment(date) {
                return moment(date)
            },
            latLng(lat, lng) {
                return [lat, lng]
            },
            centerUpdate() {
                this.isBusy = true;

                try {
                    this.zoomUpdate();
                    const self = this;
                    setTimeout(function () {
                        self.center = [self.jobsiteSelect.coordinateLat, self.jobsiteSelect.coordinateLng]
                        self.isBusy = false;
                    }, 2000);

                } catch (e) {
                    this.isBusy = false;
                }
            },
            zoomUpdate() {
                this.zoom = 15
            },
            showInfo() {
                if (this.jobsiteSelect == null) {
                    this.isActive = false
                } else {
                    this.isActive = true
                }
            },
            async jsonConcatNOT() {
                this.isBusy = true;
                this.geoJsonToUse = [];

                const array = this.jobsiteSelect.workunits
               
                const not = array.filter(url => url.statePathDriver != true)
                
                let json = []
                for (const i in not) {
                    let isError = false;
                    const data2 = await axios
                        .get(this.pathBase + this.jobsiteSelect.workunits[i].pathGeojson)
                        .then(response => {
                            isError = false;
                            return response.data
                        })
                        .catch(e => {
                            isError = true;
                            console.error('error' + e)
                        })

                    if (isError == false) {
                        for (let iFeature = 0; iFeature < data2.features.length; iFeature++) {
                            const geometry = data2.features[iFeature].geometry;
                            if (geometry.coordinates < 2) {
                                data2.features.splice(iFeature, 1);
                                iFeature = -1;
                            }
                        }
                        json.push(data2)
                        let geojson = JSON.parse(JSON.stringify(data2));
                        this.geoJsonToUse.push({ workunit: this.jobsiteSelect.workunits[i], geojson: geojson });
                    }
                }
                this.geojsonNOT = json
                const self = this;
                Promise.all(json).then(() => {
                    setTimeout(function () {
                        try {
                            self.jsonConcatOK();

                        } catch (e) {
                            console.error('Errorr:' + e.message)
                        }
                    }, 150)
                })
            },
            async jsonConcatOK() {
                try {
                    if (this.geoJsonToUse != null && typeof (this.geoJsonToUse) != 'undefined') {
                        let jsonOK = [];


                        for (let igeoJson = 0; igeoJson < this.geoJsonToUse.length; igeoJson++) {
                            let lengthWorkTotal = 0;
                            const currentGeoJson = this.geoJsonToUse[igeoJson];
                           
                           /**
                            * check if we have to force the end of the drive. 
                            */
                            for (let iworkunitadvance = 0; iworkunitadvance < currentGeoJson.workunit.workunitadvance.length; iworkunitadvance++) {
                                if(currentGeoJson.workunit.force_end_drive){
                                    lengthWorkTotal = parseFloat(currentGeoJson.workunit.discLenght);
                                } else {
                                    lengthWorkTotal = parseFloat(currentGeoJson.workunit.workunitadvance[0].lenghtAccumulated);
                                }
                                
                            }
                             
                            let arrayOFCoordinates = [];
                            
                            if (lengthWorkTotal > 0) {
                                
                                const currentJson = this.geojsonNOT[igeoJson];
                                const currenJsonForUse = JSON.parse(JSON.stringify(currentJson));
                                let totalMetersJson = 0.0;
                                let metersDraw = 0.0;

                                    for (let f = 0; f < currenJsonForUse.features.length; f++) {
                                    const geometry = currenJsonForUse.features[f].geometry;
                                    const currentCoordenates = geometry.coordinates;

                                    /**
                                     * @inversion Check if the coordinates need to be inverse with
                                     * - Reverse the coordinates with reverse function() and replace them.
                                     */
                                    for(let i = 0; this.jobsiteSelect.workunits.length > i; i++ ){
                                        if(this.jobsiteSelect.workunits[i].inversion){
                                            reverse(currentCoordenates);
                                        }
                                    }

                                    for (let c = 0; c < currentCoordenates.length; c++) {
                                        if ((c + 1) < currentCoordenates.length) {

                                            const from = turf.point([currentCoordenates[c][0], currentCoordenates[c][1]]);
                                            const to = turf.point([currentCoordenates[c + 1][0], currentCoordenates[c + 1][1]]);
                                            
                                            const optionsDistance = { units: 'miles' };
                                            const distance = turf.distance(from, to, optionsDistance);

                                            const meters = distance / 0.000621371;
                                            totalMetersJson += meters;

                                            if (totalMetersJson <= lengthWorkTotal) {
                                                
                                                if (arrayOFCoordinates.length == 0) {
                                                    arrayOFCoordinates.push(JSON.parse(JSON.stringify(currentCoordenates[c])));
                                                }

                                                metersDraw = totalMetersJson;
                                                arrayOFCoordinates.push(JSON.parse(JSON.stringify(currentCoordenates[c + 1])));

                                                } else {
                                                    break;
                                                }
                                            }
                                            
                                        }
                                    }

                                    if (metersDraw < lengthWorkTotal && totalMetersJson > lengthWorkTotal) {

                                        const line = turf.lineString(
                                            [
                                                arrayOFCoordinates.length > 0 ?
                                                arrayOFCoordinates[arrayOFCoordinates.length - 1] :
                                                currenJsonForUse.features[0].geometry.coordinates[0],

                                                arrayOFCoordinates.length > 0 ?
                                                currenJsonForUse.features[0].geometry.coordinates[arrayOFCoordinates.length] :
                                                currenJsonForUse.features[0].geometry.coordinates[1]

                                            ]);
                                        
                                        const options = { units: 'miles' };
                                        const along = turf.along(line, (0.000621371 * (lengthWorkTotal - metersDraw)), options);

                                        if (arrayOFCoordinates.length == 0) {
                                            arrayOFCoordinates.push(currenJsonForUse.features[0].geometry.coordinates[0]);
                                        }

                                        arrayOFCoordinates.push([along.geometry.coordinates[0], along.geometry.coordinates[1], 0]);
                                        currenJsonForUse.features[0].geometry.coordinates = arrayOFCoordinates;
                                        jsonOK.push(currenJsonForUse);
                                        
                                        } else {
                                            currenJsonForUse.features[0].geometry.coordinates = arrayOFCoordinates;
                                            jsonOK.push(currenJsonForUse);
                                        }
                            }
                        }

                        this.geojsonOK = jsonOK;

                    }
                } catch (e) {
                    alert('Error:' + e.message);
                }

                this.isBusy = false;

            },
        },
        computed: {

            styleFunctionNOT() {
                const fillColor = this.fillColor
                return () => {
                    return {
                        weight: 4,
                        color: '#ff3333',
                        opacity: 0.7,
                        fillColor: fillColor,
                        fillOpacity: 0.7,
                    }
                }
            },
            styleFunctionOK() {
                const fillColor = this.fillColor
                return () => {
                    return {
                        weight: 5,
                        color: '#2024f3',
                        opacity: 1,
                        fillColor: fillColor,
                        fillOpacity: 1,
                    }
                }
            },
        },
    }
</script>
<style lang="scss" scope>

    .map {
        height: 80vh;
        border-radius: 6px;
        z-index: 5;
    }

    .mensaje-map {
        z-index: 10;
        position: absolute;
        margin: 60px;
    }

    .leaflet-pane {
        z-index: 1;
    }

    .leaflet-top,
    .leaflet-bottom {
        z-index: 10;
    }
    .leaflet-popup-content{
         
        min-width: 300px;
    }
    .leaflet-popup-content p {
        margin: 0;
    }
    .adress-format{
        white-space: pre;
    }
</style>

